import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import JsZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';
import {json2excel, excel2json} from 'js2excel';
import moment from 'moment'
import PageTracker from '../../../../common/PageTrackerHelper'
import {
  BasicSelect
} from 'vue-search-select';
import keycloak from '../../../../common/Keycloak';


export default {
  name: 'ReverseRunsheetClosure',
  components: {
      VueElementLoading,
      Paginate,
      JsZip,
      BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
      return {
        hubname: '',
        hubZoneList:[],
        hubServiceCenterList:[],
        client:'',
        clientList:[],
        ShippingID:'',
        ShippingIDArray:[],
        ReverseRunsheetList:[],
        ScanPODList:[],
        changeStatus : '0',
        searchFlag:false,
        localuserid : '',
        localusermailid : '',
        rolename : '',
        NodetailsFlag:false,
        pageno: 1,
        pagecount: 0,
        updateListFlag:false,
        FlayerBarcode: '',
        updateList:[],
        updateList2:[],
        updatedFlayerBarcodes:[],
        validateBarcodeFlag:false,
        dateobj : {
          startDate : '',
          endDate:''
        },
        FlayerBarcodeList:[],
        batchID:'',
        batchIDList:[],
        DeliveryUserList:[],
        DeliveryUser:'',
        picked:'',
        updatePickUPList:[],
        updatePickUPList2:[],
        isFlayerBarcodeList:false,
        srLoader :'',
        loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
        srList : [],
        srItemObj:{ value: "",text: ""},
        clientItemObj:{ value: "",text: ""},
        searchLoader:false,
        updateFlayerBarcodeLoader:false,
        ReasonList:[{ value: "1",text: "Damage Flyer Barcode"},{ value: "2",text: "Duplicate Flyer Barcode"},{ value: "3",text: "Missing Flyer Barcode"},{ value: "4",text: "Require New Flyer Barcode"},{ value: "5",text: "Other"}],
        ReasonItemObj:{ value: "",text: ""},
        Reason:'',
        userDataKey : '',
      }
  },
  created: function() {
  //this.changeDateFormat();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail',userdetail);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubname = userdetail.hubdetails[0];
    this.getClientList();
    this.getHubzoneIDByHubID(this.hubname)
    //this.hubzone = '2'

    //this.getHubServiceCenterData();
    this.pageno= 1,
    this.loadSRList(this.hubname)
    //this.getDeliveryUserlist(this.hubname)
    this.OutSourcingMasterId = userdetail.outsourcingid;

    // let TrackerInfo = {
    //     projectname:"Lastmile-web",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  methods : {

    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []

      if(hubid) {
        this.input = {
          "usertype":"3",
          "hubid":[hubid]
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            this.srArrayList = result.data.data.results;
            for (var i = 0; i < this.srArrayList.length; i++) {
              this.srList.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
            }

          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    getSRs(obj){
      this.srItemObj = obj
      this.DeliveryUser = this.srItemObj.value
      this.getBatchIDs()
    },
    getclients(obj){
      this.clientItemObj = obj
      this.client = this.clientItemObj.value
    },
    getReason(obj){
      this.ReasonItemObj = obj
      this.Reason = this.ReasonItemObj.text
    },

  exportReverseRunsheetList(){
    this.updateFlayerBarcodeLoader = true

    return new Promise(async (resolve,reject) => {
      let serchData = {
        "HubId":this.hubname,
        "PageNo" : JSON.stringify(this.pageno)
       }

      if(this.client){
        serchData.ClientBusinessAccountId = this.client
      }
      if (this.ShippingID) {
        serchData.ShippingId = this.ShippingID
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/getReverseShipmentsAgainsthub',
          'data': serchData
      })
      .then(async result => {

        if(result.data.code == 200){
           let reverseShipment = {}
           let finalExportArray = []
           result.data.data.map(shipment =>{
             reverseShipment.ShippingID = shipment.ShippingID
             reverseShipment.CustomerName = shipment.CustomerAddressDetails.Primary.Name
             reverseShipment.CustomerAddress = shipment.CustomerAddressDetails.Primary.Address
             reverseShipment.ClientName = shipment.ClientName
             reverseShipment.PickupSlotsDate = shipment.PickupSlotsDate
             reverseShipment.Pincode = shipment.CustomerAddressDetails.Primary.PinCode
             reverseShipment.TotalItems = shipment.Quantity
             reverseShipment.FlyerBarcode = shipment.flyerbarcode
             finalExportArray.push(reverseShipment)
             reverseShipment = {}
           })

          let data = finalExportArray
          try {
              json2excel({
                  data,
                  name: 'Reverse-Shipment-List',
                  formateDate: 'yyyy/mm/dd'
              });
              this.updateFlayerBarcodeLoader = false
          } catch (e) {
              console.error('export error');
          }
        }else{
            this.$alertify.error(result.data.message);
        }
      })
      resolve()
    })
  },

  exportFlayerBarcodeList(){
    return new Promise(async (resolve,reject) => {
      this.updateFlayerBarcodeLoader = true
      serchData = {
        "HubId":(this.hubname).toString(),
        "BatchId" : this.batchID,
        "DeliveryUserId":this.DeliveryUser
       }
       if((this.dateobj).startDate){
        serchData.FromDate = (this.dateobj).startDate
       }
       if((this.dateobj).endDate){
        serchData.ToDate = (this.dateobj).endDate
       }
       axios({
           method: 'POST',
           'url':apiUrl.api_url + 'expose/get/batchwise/pending/details',
           //'url': "http://lastmileallocationpod-apistage.xbees.in/expose/get/batchwise/pending/details",
           'data': serchData
       })
       .then(async result => {
         this.searchLoader = false
         if(result.data.code == 200){
           result.data.data.map(shipment=>{
             delete shipment.IsPickUpDone
             delete shipment.IsPickUpAttemped
             delete shipment.IsAttemptedButNotPickup
             shipment.AssignDate = shipment.AssignDate?moment(shipment.AssignDate).format('YYYY-MM-DD'):null;
           })

           let data = result.data.data
           try {
               json2excel({
                   data,
                   name: 'Reverse-Shipment-List',
                   formateDate: 'yyyy/mm/dd'
               });
               this.updateFlayerBarcodeLoader = false
           } catch (e) {
               console.error('export error');
           }
         }else{
             this.$alertify.error(result.data.message);
         }
        resolve()
       })
    })
  },
    getBatchIDs(){
      this.batchIDList= []
        //axios.post("http://lastmileallocationpod-apistage.xbees.in/expose/get/reverse/batchid", {"UserHubID": this.hubname,"DeliveryUserID" : this.DeliveryUser})
       axios.post(apiUrl.api_url + 'expose/get/reverse/batchid', {"UserHubID": this.hubname,"DeliveryUserID" : this.DeliveryUser})
       .then((response) => {
         if(response.data.code == 200){
           this.batchIDList = response.data.PrintBatchId
         }else{
           this.$alertify.error("Batch ID not Avialable.");
         }
       })
       .catch((httpException) => {
           this.$alertify.error("Error while getting batchIDs");
           console.error('exception is:::::::::', httpException)
       })
    },
    updateFlayerBarcode(){
      if (this.validateBarcodeFlag == true) {
        if ((this.updateList).length != 0) {
           this.updateFlayerBarcodeLoader = true
           this.updatedFlayerBarcodes = []

           let id = "#FlayerBarcode"+this.ShippingID;
           let input = {
             flyerbarcode : $(id).val(),
             shippingid : this.ShippingID
           }

           axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/flyerbarcode/check/exist',
            data: input
          })
          .then((response)=>{
            if(response.data.code===200){
              axios({
                method: 'POST',
                url: apiUrl.api_url + 'external/updateflyerbarcode',
                data: this.updateList
              })
            //axios.post(apiUrl.api_url + 'external/updateflyerbarcode', this.updateList)
             .then((response) => {
                 this.updateFlayerBarcodeLoader = false
                 if(response.data.code===200){
                   this.updatedFlayerBarcodes = response.data.data
                   this.updateListFlag = true
                   this.$alertify.success("Flayer Barcode Updated Successfully..");
                 }
                 else {
                     this.$alertify.error("Error while update");
                 }
             })
             .catch((httpException) => {
                 this.$alertify.error("Error while update");
                 console.error('exception is:::::::::', httpException)
             })
            }
            else{
              this.$alertify.error(response.data.message)
            }
          })
        }
        else {
          this.$alertify.error("Please Enter FlyerBarcode to update");
        }
      }
      else {
        this.$alertify.error("FlyerBarcode should be Start with RVPS/RVPM/RVPL/RVPN and length should be 12");
      }
    },
    async updatePickup(){
      if((this.updatePickUPList).length != 0){
      let reqOBJ = {
        "DeliveryUserId": this.DeliveryUser,
        "PrintBatchId": this.batchID,
        "CreatedBy": this.localusermailid,
        HubId:(this.hubname).toString(),
        ShipmentDetails: this.updatePickUPList
     }
        //axios.post("http://lastmileallocationpod-apistage.xbees.in/expose/set/batchwise/pending/details",reqOBJ)
        axios.post(apiUrl.api_url + 'expose/set/batchwise/pending/details', reqOBJ)
         .then((response) => {

             if(response.data.code===200){
               this.$alertify.success("PickUp status updated successfully..");
               // this.updatedFlayerBarcodes = response.data.data
               // this.updateListFlag = true
             }
             else {
                 this.$alertify.error("Error while update");
             }
         })
         .catch((httpException) => {
             this.$alertify.error("Error while update");
             console.error('exception is:::::::::', httpException)
         })
      }else{
        this.$alertify.error("Please select PickUp status to update");
      }
    },
    async pickedChange(flyerbarcode,ShippingId,selected,TotalItems,AssignDate){
      //let id = "#picked"+shippingid;
      this.updatePickUPList = []
      this.updatePickUPList2[ShippingId] = {
        ShippingId: ShippingId,
        ShipmentStatus: selected,
        FlyerBarCode: flyerbarcode,
        TotalItems: (TotalItems).toString(),
        AssignDate: AssignDate
      };
      for (var key in this.updatePickUPList2) {
        this.updatePickUPList.push(this.updatePickUPList2[key]);
      }
    },
    async FlyerBarcodeChange(shippingid){
      this.updateList = [];
      let id = "#FlayerBarcode"+shippingid;
      let flayerbarcode = $(id).val();

      if(flayerbarcode.substring(0, 4).toLowerCase() == "rvps" || flayerbarcode.substring(0, 4).toLowerCase() == "rvpm" || flayerbarcode.substring(0, 4).toLowerCase() == "rvpl"|| flayerbarcode.substring(0, 4).toLowerCase() == "rvpn"){

         if (flayerbarcode.length == 12) {
           this.updateList2[shippingid] = {
             ShippingID : shippingid,
             Flyerbarcode:flayerbarcode,
             LastModifiedBy:this.localusermailid,
             Remarks:this.Reason,
             UpdatedBy:this.localusermailid
           };
           for (var key in this.updateList2) {
             this.updateList.push(this.updateList2[key]);
           }

            this.validateBarcodeFlag = true
           //this.updateListFlag = true
         }else {
             this.validateBarcodeFlag = false
           this.$alertify.error("FlyerBarcode should be Start with RVPS/RVPM/RVPL/RVPN and length should be 12");
         }
      }else {
        this.validateBarcodeFlag = false
        this.$alertify.error("FlyerBarcode should be Start with RVPS/RVPM/RVPL/RVPN and length should be 12");
      }
    },
    getHubzoneIDByHubID(hubid){

      let payloadData = {"hubids": [parseInt(this.hubname)]}
      axios.post(apiUrl.api_url + 'external/hubservicecenter/hubarray/get/hubzoneid', payloadData)
       .then((response) => {
         let hubname = (this.hubname).toString()
         let res = response.data.data
           if(response.data.code===200){

               this.hubzone =response.data.data[hubname];
               this.getHubListByZone()
           }
           else {
               this.hubzone='';
           }
       })
       .catch((httpException) => {
           this.$alertify.error("hub data not found");
           console.error('exception is:::::::::', httpException)
       })
    },
    //to get client list
    getClientList() {
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'external/clientbusiness/account/dropdown/byunitflowservice',
              'data':
                {   BusinessUnit : "Ecomm",
                    BusinessFlow: "Reverse",
                    BusinessService : "Pickup"}
          })
        .then((response) => {
            if(response.data.code===200){
                this.clientArrayList=response.data.data;
                for (var i = 0; i < this.clientArrayList.length; i++) {
                  this.clientList.push({
                    value: this.clientArrayList[i].ClientBusinessAccountId,
                    text: `${this.clientArrayList[i].AccountName}`
                  })
                }
            }
            else {
                this.clientList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("client data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      this.users = []
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList=response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("Hub data not found");
              console.error('exception is:::::::::', httpException)
        })

    },
    getHubListByZone() {

      axios.get(apiUrl.api_url + `external/getzonewisehublist?zoneid=`+ parseInt(this.hubzone), {})
        .then((response) => {
            if(response.data.code === 200){
                this.hubServiceCenterList = response.data.data.sort(function(a, b){
                 var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                 if (nameA < nameB) //sort string ascending
                  return -1
                 if (nameA > nameB)
                  return 1
                 return 0 //default return value (no sorting)
                });

            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              //this.$alertify.error("Hub data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.GetSearchDataForRunsheet();
    },
    searchdata(){
      this.pageno = 1;
      if(this.$refs.paginate){
        this.$refs.paginate.selected = 0;
      }
      this.GetSearchDataForRunsheet();
    },
    getReverseRunsheetData(serchData){

     this.ReverseRunsheetList=[]
     this.updateListFlag=false
     this.FlayerBarcode= ''
     this.updateList=[]
     this.updateList2=[]
     this.searchLoader = true
     axios({
         method: 'POST',
         'url': apiUrl.api_url + 'external/getReverseShipmentsAgainsthub',
         'data': serchData
     })
     .then(async result => {
          this.searchLoader = false
       if(result.data.code == 200){
          this.searchFlag = true
          let reverseShipment = {}
          result.data.data.map(shipment =>{
            reverseShipment.ShippingID = shipment.ShippingID
            reverseShipment.CustomerName = shipment.CustomerAddressDetails.Primary.Name
            reverseShipment.CustomerAddress = shipment.CustomerAddressDetails.Primary.Address
            reverseShipment.ClientName = shipment.ClientName
            reverseShipment.PickupSlotsDate = shipment.PickupSlotsDate
            reverseShipment.Pincode = shipment.CustomerAddressDetails.Primary.PinCode
            reverseShipment.TotalItems = shipment.Quantity
            reverseShipment.FlyerBarcode = shipment.flyerbarcode
            this.ReverseRunsheetList.push(reverseShipment)
            reverseShipment = {}
          })
         let totalRows = result.data.totalCount;

          if (totalRows < 50) {
              this.pagecount = 1;
          } else {
              this.pagecount = Math.ceil(totalRows / 50)
          }

       }else{
           this.searchFlag = false
           this.NodetailsFlag = true
           this.ReverseRunsheetList = []
           this.$alertify.error(result.data.message);
       }
     })
    },
    getFlayerBarcodeListForUpdate(serchData){
      // serchData = {
      //     "HubId": "614",
      //     "BatchId": "PDS203511113813252",
      //     "DeliveryUserId": "13252",
      //  }
      this.FlayerBarcodeList = []
      axios({
          method: 'POST',
          'url':apiUrl.api_url + 'expose/get/batchwise/pending/details',
          //'url': "http://lastmileallocationpod-apistage.xbees.in/expose/get/batchwise/pending/details",
          'data': serchData
      })
      .then(async result => {
        this.searchLoader = false
        if(result.data.code == 200){
          result.data.data.map(shipment=>{
            delete shipment.IsPickUpDone
            delete shipment.IsPickUpAttemped
            delete shipment.IsAttemptedButNotPickup
            shipment.AssignDate = shipment.AssignDate?moment(shipment.AssignDate).format('YYYY-MM-DD'):null;
          })
          this.FlayerBarcodeList = result.data.data

          let totalRows = result.data.totalCount;

          if (totalRows < 10) {
              this.pagecount = 1;
          } else {
              this.pagecount = Math.ceil(totalRows / 10)
          }
          this.isFlayerBarcodeList = true

        }else{

            this.isFlayerBarcodeList = true
            this.FlayerBarcodeList = []
        }
      })

    },
      GetSearchDataForRunsheet(){
      this.$validator.validateAll().then(result => {
        if(result) {
          let serchData = {};

          if(this.changeStatus == '0'){

            serchData = {
              "HubId":this.hubname,
              "PageNo" : JSON.stringify(this.pageno)
             }

            if(this.client){
              serchData.ClientBusinessAccountId = this.client
            }
            if (this.ShippingID) {
              serchData.ShippingId = this.ShippingID
              delete serchData.HubId
            }
            this.getReverseRunsheetData(serchData);


          } else {
            serchData = {
              "HubId":(this.hubname).toString(),
              "BatchId" : this.batchID,
              "DeliveryUserId":this.DeliveryUser
             }
             if((this.dateobj).startDate){
              serchData.FromDate = (this.dateobj).startDate
             }
             if((this.dateobj).endDate){
              serchData.ToDate = (this.dateobj).endDate
             }
             this.getFlayerBarcodeListForUpdate(serchData)
          }

      }
    })
    },
    getHubList(){
       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList =response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    getUserList(){
      this.users = []

       let payloadData = {"HubID":[parseInt(this.hubname)]}
       let apiendpoint = 'external/getremoteuserdetails/byhubid';
       if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getuserdetailsbyhubids';
       }
       axios.post(apiUrl.api_url + apiendpoint, payloadData)
        .then((response) => {
            if(response.data.code===200){
                this.users =response.data.data.results;
            }
            else {
                this.users=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("user list data not found");
            console.error('exception is:::::::::', httpException)
        })
    },

    getshipmentTypes(){
       axios.post(apiUrl.api_url + 'external/businessconfig/get/list',{})
        .then((response) => {
            if(response.data.code===200){
                this.shipmentTypeList =response.data.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("Shipment type data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
   setFileType(e){
     let selectedShipType = $("#shipmentType option:selected").text();
     this.fileTypeArray = [];
     this.fileType = '';
     if(selectedShipType == 'eComm-Reverse-PickUp'){
       this.fileTypeArray.push('DTOWHHandover');
     } else {
       this.fileTypeArray.push('Delivery','WHHandover');
     }
   },

   clearUpdateList(){
     this.FlayerBarcode= ''
     this.updateList=[]
     this.updateListFlag=false
     this.GetSearchDataForRunsheet()
   },
    clearAll(){
      this.clientItemObj= { value: "",text: ""}
      this.ReasonItemObj={ value: "",text: ""}
      this.Reason =''
      this.ScanPODList = []
      this.imgUrls =[]
      this.ShippingIDArray =[]
      this.pageno= 1,
      this.pagecount= 0,
      this.$validator.reset();
      this.errors.clear();
      this.searchFlag = false
      this.NodetailsFlag = false
      this.dateobj = {
        startDate : '',
        endDate:''
      },
      this.shipmentType = ''
      this.fileType =''
      this.userID =''
      this.client=''
      this.ShippingID=''
      this.ShippingIDArray=[]
      this.ReverseRunsheetList=[]
      this.updateListFlag=false
      this.FlayerBarcode= ''
      this.updateList=[]
      this.updateList2=[]
      this.updatePickUPList=[]
      this.updatePickUPList2= []
      this.FlayerBarcodeList=[]
      this.batchID=''
      this.DeliveryUser='',
      this.isFlayerBarcodeList = false
    },
  }
}

Validator.extend('verify_shipments', {
  getMessage: field => "Invalid ShippingId. Please enter valid shippingID with comma separate.",
  validate: value => {
      var ShippingID = $("#ShippingID").val();
      let ShippingIDs=ShippingID.split(/[,]+/);
      let flag=0;
      for (let i = 0; i < ShippingIDs.length; i++) {
        if(isNaN(ShippingIDs[i]) || (ShippingIDs[i].length<3)){
          flag=1;
        }
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});
Validator.extend('max_shipments', {
  getMessage: field => "maximum 50 Shipments you can enter",
  validate: value => {
      var shippingIDs = $("#ShippingID").val();
      let shipment=shippingIDs.split(/[,]+/);
      if(shipment.length>50){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/ReverseRunsheetClosure/ReverseRunsheetClosure/ReverseRunsheetClosure.component.js